import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';

class FeaturedLogos extends HTMLElement {
  constructor() {
    super();
    this.mobileBreakpoint = 720;
    this.swiper = null;
    // New property to determine if we should use mobile-only logic
    this.mobileOnly = false;
  }

  connectedCallback() {
    const sliderContainer = this.querySelector('.swiper');

    if (this.mobileOnly) {
      // Only run breakpoint logic if mobile-only is enabled
      this.initOrDestroySlider(window.innerWidth);

      this.resizeObserver = new ResizeObserver((entries) => {
        const width = entries[0].contentRect.width;
        this.initOrDestroySlider(width);
      });

      if (sliderContainer) {
        this.resizeObserver.observe(sliderContainer);
      }
    } else {
      // Initialize slider for all screen sizes
      this.initSlider();
    }
  }

  initSlider() {
    const sliderContainer = this.querySelector('.swiper');
    if (!this.swiper && sliderContainer) {
      // Calculate total width of all slides
      const slides = sliderContainer.querySelectorAll('.swiper-slide');
      let totalSlidesWidth = 0;
      slides.forEach((slide) => {
        totalSlidesWidth += slide.offsetWidth + 24; // Adding spaceBetween value
      });

      // Compare with container width to determine if looping is needed
      const shouldLoop = totalSlidesWidth > sliderContainer.offsetWidth;

      this.swiper = new Swiper(sliderContainer, {
        slidesPerView: 'auto',
        resizeObserver: true,
        spaceBetween: 24,
        modules: [Pagination, Autoplay],
        loop: shouldLoop,
        speed: 10000,
        autoplay: shouldLoop
          ? {
              delay: 0,
              disableOnInteraction: false,
            }
          : false,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    }
  }

  initOrDestroySlider(width) {
    if (width <= this.mobileBreakpoint) {
      this.initSlider();
    } else {
      // Destroy if exists
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  disconnectedCallback() {
    // Clean up
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('featured-logos', FeaturedLogos);
